<template>
  <div>
    <!-- TOOLBAR WITH TABS -->
    <v-toolbar
      color="theme_primary"
      dark
      extension-height="36"
      height="36"
      flat
      app
    >
      <v-toolbar-side-icon @click="drawerToggle()">
        <v-icon>{{ drawerIcon() }}</v-icon>
      </v-toolbar-side-icon>
      <v-layout align-center>
        <v-icon size="12" left>{{ pageIcon }}</v-icon>
        <v-breadcrumbs
          :items="[
            {
              exact: true,
              text: capitalize(contractStatusOrArchived) + ' contracts',
              disabled: false,
              to: '/contracts?tab=' + (contractStatusOrArchived + 'Contracts'),
            },
          ]"
          dark
        >
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>

        <v-icon>chevron_right</v-icon>
        <span class="breadcrumb_current_page">{{ pageTitle }}</span>

        <v-spacer></v-spacer>
        <headerProfile />
      </v-layout>
      <template v-slot:extension v-if="!isNewContract">
        <v-tabs
          v-model="contract_tab"
          show-arrows
          left
          color="transparent"
          slider-color="primary"
          height="36"
        >
          <v-tab
            active-class="active-tab primary--text"
            href="#contract_settings"
          >
            <v-icon small>settings</v-icon>
            <span class="font-weight-bold pl-2">Contract Settings</span>
          </v-tab>
          <v-tab active-class="active-tab primary--text" href="#contract_score">
            <v-icon small>monetization_on</v-icon>
            <span class="font-weight-bold pl-2">Score</span>
          </v-tab>

          <v-tab active-class="active-tab primary--text" href="#contract_steps">
            <v-icon small>mdi-format-list-checks</v-icon>
            <span class="font-weight-bold pl-2">Contract Steps</span>
          </v-tab>

          <v-tab
            active-class="active-tab primary--text"
            href="#contract_expeditions"
            :disabled="
              !contract.expeditions || contract.expeditions.length == 0
            "
          >
            <v-icon
              :disabled="
                !contract.expeditions || contract.expeditions.length == 0
              "
              small
              >mdi-ferry</v-icon
            >
            <span class="font-weight-bold pl-2"
              >Expeditions ({{
                loading
                  ? "---"
                  : contract.expeditions && contract.expeditions.length
              }})</span
            >
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <!-- Archive contract -->
    <v-toolbar
      dark
      color="amber darken-3"
      flat
      height="36"
      v-if="!loading && contractCompleted && !contract.archived"
    >
      <v-flex class="text-xs-center pb-1">
        <span>
          <v-icon class="pr-2" color="white" small>info</v-icon>

          Every shipments has been delivered.
          <a
            class="pl-1 font-weight-bold white--text"
            style="text-decoration: underline"
            @click="actionArchive()"
            >You can archive this contract.</a
          >
        </span>
      </v-flex>
    </v-toolbar>

    <!-- Validate contract -->
    <v-toolbar
      dark
      color="success"
      flat
      height="36"
      v-if="!loading && canValidateContract && !contract.archived && canValidateContractOnClick"
    >
      <v-flex class="text-xs-center pb-1">
        <span>
          <v-icon class="pr-2" color="white" small>info</v-icon>

          This contract meets the requirements for a validation.
          <a
            class="pl-1 font-weight-bold white--text"
            style="text-decoration: underline"
            @click="actionValidate()"
            >You can validate this contract.</a
          >
        </span>
      </v-flex>
    </v-toolbar>

    <!-- QUICK CONTRACT SWITCH -->
    <v-toolbar color="grey lighten-3" flat height="36" class="pr-0">
      <v-layout row align-center justify-center class="pa-0">
        <div style="width: 160px">
          <v-autocomplete
            :items="contractListGrouped"
            item-value="id"
            item-text="name"
            solo
            height="24"
            background-color="transparent"
            label="Select a contract"
            browser-autocomplete="gepaij"
            :value="$route.params.id"
            dense
            flat
            hide-details
            single-line
            @change="switchContract($event)"
          >
            <template slot="selection" slot-scope="props">
              <v-flex xs12>
                <span style="float: right">
                  {{ loading ? "------" : contract.name }}
                </span>
              </v-flex>
            </template>
            <template slot="item" slot-scope="props">
              <span class="subheadings">{{ props.item.name }}</span>
            </template>
          </v-autocomplete>
        </div>
        <span class="pl-2" v-if="!loading && !isNewContract">
          <router-link
            :to="{
              name: 'company',
              params: { id: contract.supplier_company_id },
            }"
          >
            <a class="px-2">{{
              contract &&
              contract.supplier_company &&
              contract.supplier_company.short_name
            }}</a>
          </router-link>
          <v-icon color="primary" size="12">mdi-transfer-right</v-icon>
          <router-link
            :to="{
              name: 'company',
              params: { id: contract.customer_company_id },
            }"
          >
            <a
              class="px-2"
              :to="{
                name: 'companies',
                params: { id: contract.customer_company_id },
              }"
              >{{
                contract &&
                contract.customer_company &&
                contract.customer_company.short_name
              }}</a
            >
          </router-link>
        </span>

        <span class="pl-2" v-else>
          ----
          <v-icon color="primary" size="12">mdi-transfer-right</v-icon>
          ----
        </span>
      </v-layout>

      <v-menu transition="slide-y-transition" bottom v-if="!loading">
        <template v-slot:activator="{ on }">
          <v-btn
            flat
            small
            icon
            v-on="on"
            style="position: relative; left: 16px"
            v-if="!isNewContract"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-tile
            v-for="(item, i) in contract_menu_items"
            :key="i"
            @click="item[3]()"
          >
            <v-list-tile-title>
              <v-icon small :color="item[2]" class="pr-2">{{ item[1] }}</v-icon>
              <span :style="'color: ' + item[2]">{{ item[0] }}</span>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-tabs-items
      v-model="contract_tab"
      v-if="!loading && !isNewContract"
      class="pt-2"
    >
      <v-tab-item value="contract_settings">
        <v-layout wrap row align-center justify-center>
          <v-tabs
            slider-color="primary"
            v-model="contract_settings_tab"
            fixed-tabs
            :key="contract_settings_tab"
          >
            <v-tab href="#overview">
              <v-icon small class="pr-2">menu</v-icon>OVERVIEW
            </v-tab>

            <v-tab href="#additional_informations">
              <v-icon small class="pr-2">mdi-playlist-edit</v-icon>ADDITIONAL
              INFORMATIONS
            </v-tab>

            <v-tab href="#customer_parameters">
              <v-icon small class="pr-2">mdi-format-list-checks</v-icon>CUSTOMER
              PARAMETERS
            </v-tab>
          </v-tabs>
        </v-layout>

        <!-- SAVE OR DISCARD CHANGES -->
        <transition name="bottom-sheet-transition">
          <div
            v-if="ask_user_to_save"
            role="document"
            tabindex="0"
            :class="
              getstickedToolbarClass +
              ' v-dialog__content v-dialog__content--active'
            "
            style="left: 0; top: auto; height: auto; bottom: 0px"
          >
            <div
              class="v-dialog v-dialog--active v-dialog--persistent v-bottom-sheet elevation-16"
              style="transform-origin: center center"
            >
              <v-card flat>
                <v-card-title class="pb-0">
                  <v-icon small class="pr-2" color="amber darken-1"
                    >warning</v-icon
                  >
                  <strong>Contract Update</strong></v-card-title
                >
                <v-card-text>
                  Some modifications have been applied to the current contract.
                  <br />
                  Would you like to
                  <strong>save and update the contract</strong> or do you want
                  to <strong>discard</strong> them ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="discardChanges()"
                    small
                    color="error"
                    depressed
                    dark
                  >
                    <v-icon small class="pr-2">mdi-backup-restore</v-icon>
                    Discard Changes
                  </v-btn>

                  <v-btn
                    @click="saveChanges()"
                    small
                    color="success"
                    depressed
                    dark
                  >
                    <v-icon small class="pr-2">save</v-icon>
                    Update Contract
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </div>
        </transition>

        <v-tabs-items v-model="contract_settings_tab">
          <v-tab-item value="overview">
            <newContractForm
              ref="contract_edit_form"
              :editedContract="contract"
              @updateSettings="contractSettingsUpdateNotif()"
            />
          </v-tab-item>

          <v-tab-item value="additional_informations">
            <v-layout row wrap justify-center pa-0 px-4 pt-2>
              <v-flex xs12 sm12 md12 xl10>
                <v-card flat>
                  <integratedSearchBar
                    :button_display="true"
                    button_type="function"
                    :button_function="selectAllAdditionalInformations"
                    button_label="Select all"
                    button_icon="select_all"
                    v-bind:search.sync="additionalInformationsSearch"
                    search_label="Search additionnal information..."
                  />
                  <v-data-table
                    :headers="additionalInformationsHeaders"
                    hide-headers
                    :items="additionalInformations"
                    :search="additionalInformationsSearch"
                    :pagination.sync="additionalInformationsPagination"
                    must-sort
                    rows-per-page-text="Additionnal Informations per page"
                  >
                    <v-progress-linear
                      slot="progress"
                      color="blue"
                      indeterminate
                    ></v-progress-linear>

                    <template slot="items" slot-scope="info">
                      <tr
                        @click="
                          updateAdditionalInformations(
                            info.item.id,
                            !(
                              contract.additional_information_ids &&
                              contract.additional_information_ids.includes(
                                info.item.id
                              )
                            )
                          )
                        "
                      >
                        <td style="height: 24px">
                          <v-checkbox
                            flat
                            class="py-1"
                            :label="info.item.name"
                            hide-details
                            :input-value="
                              contract.additional_information_ids &&
                              contract.additional_information_ids.includes(
                                info.item.id
                              )
                            "
                          ></v-checkbox>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item value="customer_parameters">
            <v-container fluid class="pa-0">
              <v-card flat>
                <v-layout wrap row>
                  <v-flex px-4 pt-2>
                    <integratedSearchBar
                      :button_display="false"
                      v-bind:search.sync="cust_param_search"
                      search_label="Search Customer Parameters..."
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    px-4
                    v-for="paramsGroup in customerParameterGroups"
                    :key="paramsGroup.name"
                  >
                    <v-card
                      pb-3
                      flat
                      v-if="
                        paramsGroup.customer_parameters.filter(
                          (cp) =>
                            !cust_param_search ||
                            cp.name
                              .toLowerCase()
                              .includes(cust_param_search.toLowerCase())
                        ).length > 0
                      "
                    >
                      <v-layout justify-end align-center>
                        <v-flex row wrap>
                          <div>{{ paramsGroup.name }}</div>
                        </v-flex>

                        <v-flex text-xs-right>
                          <v-btn
                            small
                            flat
                            @click="selectAllCustomerParameters(paramsGroup)"
                          >
                            <v-icon small>select_all</v-icon>Select all
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-divider></v-divider>
                      <v-container fluid pa-0>
                        <v-layout wrap row>
                          <v-flex
                            xs12
                            md6
                            lg4
                            pa-1
                            pl-3
                            style="cursor: pointer"
                            class="hoverClass"
                            v-for="params in paramsGroup.customer_parameters.filter(
                              (cp) =>
                                !cust_param_search ||
                                cp.name
                                  .toLowerCase()
                                  .includes(cust_param_search.toLowerCase())
                            )"
                            :key="params.id"
                            @click="
                              updateCustomerParameters(
                                params.id,
                                !(
                                  contract.customer_parameter_ids &&
                                  contract.customer_parameter_ids.includes(
                                    params.id
                                  )
                                )
                              )
                            "
                          >
                            <v-checkbox
                              class="pb-1"
                              height="0"
                              :label="params.name"
                              :input-value="
                                contract.customer_parameter_ids &&
                                contract.customer_parameter_ids.includes(
                                  params.id
                                )
                              "
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>

      <v-tab-item value="contract_score">
        <v-layout wrap row align-center justify-center>
          <v-tabs
            slider-color="primary"
            v-model="contract_score_tab"
            fixed-tabs
            :key="contract_settings_tab + contract_score_tab"
          >
            <v-tab href="#realscore">
              <v-icon small class="pr-2">monetization_on</v-icon>REAL SCORE
            </v-tab>

            <v-tab href="#provisionalscore">
              <v-icon small class="pr-2">monetization_on</v-icon>PROVISIONAL
              SCORE
            </v-tab>
          </v-tabs>
        </v-layout>

        <v-tabs-items v-model="contract_score_tab">
          <v-tab-item lazy value="realscore">
            <realScore v-if="contractValidated" />
            <v-layout justify-center wrap mt-4 v-else>
              <v-flex text-xs-center xs12 justify-center>
                <v-icon class="pa-5" size="90" color="#ddd"
                  >monetization_on</v-icon
                >
                <br />
                <span>
                  <v-icon color="blue" size="14" class="pr-1">info</v-icon>
                  <span class="pr-2"
                    ><b>Real Score</b> settings will be displayed here once the
                    contract has been <b>validated</b>.</span
                  >
                </span>
                <br />
                <span v-if="previsional_expeditions.length == 0">
                  <v-icon color="error" size="14" class="pr-1">warning</v-icon>
                  <span class="pr-2"
                    >A contract needs at least one
                    <b>provisionnal expedition</b> to be validated</span
                  >
                </span>
              </v-flex>
              <!-- <v-flex xs12 class="px-2">
          <v-btn
            block
            depressed
            class="white--text blue"
            @click="$emit('selectedPartialReconciliation')"
          >
            <v-icon color="white" size="16" class="pr-2"
              >mdi-swap-horizontal-bold</v-icon
            >
            <span class="white--text">Validate contract</span>
          </v-btn>
        </v-flex> -->
            </v-layout>
          </v-tab-item>

          <v-tab-item lazy value="provisionalscore">
            <previsionalScore />
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>

      <v-tab-item value="contract_steps">
        <v-layout
          justify-center
          wrap
          mt-4
          v-if="contract.status != 'validated'"
        >
          <v-flex text-xs-center xs12 justify-center>
            <v-icon class="pa-5" size="90" color="#ddd"
              >mdi-format-list-checks</v-icon
            >
            <br />
            <span>
              <v-icon color="blue" size="14" class="pr-1">info</v-icon>
              <span class="pr-2"
                ><b>Contract Steps</b> and <b>Invoice Details</b> will be
                displayed here once the contract has been
                <b>validated</b>.</span
              >
            </span>
            <br />
            <span v-if="previsional_expeditions.length == 0">
              <v-icon color="error" size="14" class="pr-1">warning</v-icon>
              <span class="pr-2"
                >A contract needs at least one <b>provisionnal expedition</b> to
                be validated</span
              >
            </span>
          </v-flex>
        </v-layout>

        <v-layout
          column
          wrap
          justify-center
          v-if="contract.status == 'validated'"
          pa-4
        >
          <contractSteps />
        </v-layout>

        <v-layout
          column
          wrap
          justify-center
          v-if="contract.status == 'validated'"
          pa-4
        >
          <invoiceDetailForm :contractInvoiceDetails="true" />
        </v-layout>
      </v-tab-item>

      <v-tab-item value="contract_expeditions">
        <expeditionsSummary />
      </v-tab-item>
    </v-tabs-items>

    <!-- Loading contract animation -->
    <div
      class="px-5 text-xs-center"
      style="padding-top: 120px"
      v-if="loading && !isNewContract"
    >
      <looping-rhombuses-spinner
        style="margin: auto"
        class="text-xs-center"
        :animation-duration="1000"
        :size="74"
        color="#1976d2"
      />
      <h3 class="title font-weight-light my-2">Loading Contract...</h3>
      <span class="caption grey--text">Please wait</span>
    </div>

    <!-- Rename Contract DIalog -->
    <v-dialog v-model="contractRenameDialog" persistent max-width="380px">
      <v-card>
        <v-card-title class="pb-0">
          <v-icon small class="pr-2" color="primary">edit</v-icon>
          <strong>Rename Contract</strong>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-text-field
            hide-details
            v-model="contract.name"
            label="Contract Name"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn small flat color="error" @click="cancelRename()"
            ><v-icon small class="pr-2">close</v-icon>Cancel</v-btn
          >
          <v-spacer />
          <v-btn small flat color="success" @click="saveChanges()"
            ><v-icon small class="pr-2">save</v-icon>Update Contract</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Contract DIalog -->
    <v-dialog v-model="contractDeleteDialog" persistent max-width="380px">
      <v-card>
        <v-toolbar dense flat color="warning" dark height="36">
          <v-layout row wrap align-center
            ><v-icon class="pr-2" small>warning</v-icon>
            <h3>Notice</h3></v-layout
          >
        </v-toolbar>

        <v-card-text v-if="!contractDeleteDialogLoading"
          >You are going to remove this Contract and its associated contacts and
          products permanently</v-card-text
        >

        <div class="py-4 text-xs-center" v-else>
          <half-circle-spinner
            style="margin: auto"
            class="text-xs-center"
            :animation-duration="1000"
            :size="48"
            color="#fb8c01"
          />
          <h4 class="pt-4">Deleting Contract...</h4>
          <span class="caption grey--text">This may take a while...</span>
        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="contractDeleteDialogLoading"
            color="red"
            small
            flat
            @click="contractDeleteDialog = false"
          >
            No</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="contractDeleteDialogLoading"
            color="warning"
            small
            depressed
            dark
            @click="contractDelete()"
            ><v-icon small class="pr-2">mdi-shield-check</v-icon>Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <newContractForm
      v-if="isNewContract"
      @contract_created="switchContract($event)"
    />

    <v-snackbar
      v-model="showSnackBar"
      bottom
      :color="showSnackBarColor"
      :timeout="2000"
    >
      <span
        ><v-icon small color="white" class="pr-1">{{
          showSnackBarIcon
        }}</v-icon>
        {{ showSnackBarText }}</span
      >
    </v-snackbar>
  </div>
</template>

<script>
import headerProfile from "../components/shared/headerProfile";
import newContractForm from "../components/contracts/newContractForm";
import pluralize from "pluralize";
import { mapGetters } from "vuex";
import CONTRACTS_INDEX from "../graphql/contracts/contract_list.gql";

import SHOW_CONTRACT from "../graphql/contracts/show.gql";
import UPDATE_CONTRACT from "../graphql/contracts/update.gql";
import DUPLICATE_CONTRACT from "../graphql/contracts/duplicate.gql";
import ARCHIVE_CONTRACT from "../graphql/contracts/archive.gql";
import UNARCHIVE_CONTRACT from "../graphql/contracts/unarchive.gql";
import VALIDATE_CONTRACT from "../graphql/contracts/validate.gql";

import { LoopingRhombusesSpinner } from "epic-spinners";
import { HalfCircleSpinner } from "epic-spinners";
import previsionalScore from "../components/contracts/previsionalScore";
import realScore from "../components/contracts/realScore";
import integratedSearchBar from "../components/shared/integratedSearchBar";
import expeditionsSummary from "../pages/expeditionsSummary";
import contractSteps from "../components/steps/contractSteps";
import invoiceDetailForm from "../components/expeditions/invoiceDetailForm";

export default {
  mixins: [],
  components: {
    newContractForm,
    headerProfile,
    LoopingRhombusesSpinner,
    HalfCircleSpinner,
    integratedSearchBar,
    expeditionsSummary,
    previsionalScore,
    realScore,
    contractSteps,
    invoiceDetailForm,
  },

  data() {
    return {
      contract_tab: "contract_settings",
      contract_settings_tab: "overview",
      canValidateContractOnClick: true,
      contract_score_tab: null,
      loading: false,
      pluralize,
      contracts_list: [],
      loading: false,
      cust_param_search: "",
      ask_user_to_save: false,
      changes_discarded: false,
      changes_saved: false,

      additionalInformationsSearch: "",
      additionalInformationsHeaders: [
        {
          text: "",
          align: "left",
          value: "name",
        },
      ],
      additionalInformationsPagination: {
        descending: false,
        sortBy: "name",
        rowsPerPage: 25,
      },
      contract_customers_parameters: [],
      contract_additionnal_informations: [],
      showSnackBar: false,
      showSnackBarText: "",
      showSnackBarIcon: "mdi-backup-restore",
      showSnackBarColor: "amber darken-2",
      contractRenameDialog: false,
      contractNameTemp: "",
      contractDeleteDialog: false,
      contractDeleteDialogLoading: false,
    };
  },
  computed: {
    ...mapGetters("contractStore", ["contract", "previsional_expeditions"]),
    ...mapGetters("commonStore", [
      "additionalInformations",
      "additionalInformationsIds",
      "customerParameterGroups",
    ]),
    canValidateContract() {
      return (
        this.contract.archived == false &&
        this.contract.status == "pending" &&
        this.previsional_expeditions.length
      );
    },
    contractCompleted() {
      if (this.contract.status == "pending") return false;

      for (let i in this.contract.expeditions) {
        if (
          !this.contract.expeditions[i].previsional &&
          !this.contract.expeditions[i].done
        )
          return false;
      }
      return true;
    },
    contract_menu_items() {
      let retArray = [];

      retArray.push(["Rename contract", "edit", "", this.actionRename]);
      retArray.push([
        "Edit contract settings",
        "settings",
        "",
        this.actionEditContractSettings,
      ]);
      retArray.push([
        "Duplicate contract",
        "mdi-content-copy",
        "",
        this.actionDuplicate,
      ]);

      if (this.canValidateContract)
        retArray.push([
          "Validate contract",
          "mdi-check",
          "#3f9242",
          this.actionValidate,
        ]);

      retArray.push([
        (this.contract.archived ? "Unarchive" : "Archive") + " contract",
        "mdi-archive",
        "#e6a101",
        this.contract.archived ? this.actionUnarchive : this.actionArchive,
      ]);

      retArray.push([
        "Delete contract",
        "delete",
        "#ff5252",
        this.actionDelete,
      ]);

      return retArray;
    },
    isNewContract() {
      return !this.$route.params.id;
    },
    pageIcon() {
      return this.$route.params.id ? "edit" : "note_add";
    },
    pageTitle() {
      if (this.loading) {
        return "------";
      }
      if (this.$route.params.id)
        return "Edit contract: " + `${this.contract.name}`;
      else return "Create a new contract";
    },
    contractListGrouped() {
      // Group expeditions by Non completed expeditions first, then completed ones after.

      let arr_validated = [{ header: "Validated Contracts" }];
      let arr_pending = [{ header: "Pending Contracts" }];
      let retArray = [];

      this.contracts_list.forEach((c) => {
        if (c.status == "validated") {
          arr_validated.push(c);
        } else if (c.status == "pending") {
          arr_pending.push(c);
        }
      });

      if (arr_validated.length > 1) retArray = retArray.concat(arr_validated);

      if (arr_pending.length > 1) retArray = retArray.concat(arr_pending);

      return retArray;
    },
    getstickedToolbarClass() {
      switch (this.drawerState) {
        case 0:
          return "sticky-toolbars-no-menu";
        case 1:
          return "sticky-toolbars-small-menu";
        case 2:
          return "sticky-toolbars-big-menu";
      }
    },
    contractStatusOrArchived() {
      if (this.contract.archived) return "archived";
      else return this.contractValidated ? "validated" : "pending";
    },
    contractValidated() {
      return !this.isNewContract && this.contract.status != "pending";
    },
  },
  methods: {
    actionRename() {
      this.contractRenameDialog = true;
      this.contractNameTemp = this.contract.name;
    },
    cancelRename() {
      this.contractRenameDialog = false;
      this.contract.name = this.contractNameTemp;
    },
    actionEditContractSettings() {
      this.contract_tab = "contract_settings";
      this.contract_settings_tab = "overview";
      this.$refs.contract_edit_form.editContractToggle();
    },
    actionDuplicate() {
      this.sendMutation("no-notif", "contract", DUPLICATE_CONTRACT, {
        id: this.contract.id,
      }).then((data) => {
        this.showSnackBar = true;
        this.showSnackBarText = "The contract has been duplicated";
        this.showSnackBarIcon = "mdi-content-copy";
        this.showSnackBarColor = "success";
        this.switchContract(data.duplicate_contract.id);
      });
    },
    actionArchive() {
      this.sendMutation("no-notif", "contract", ARCHIVE_CONTRACT, {
        id: this.contract.id,
      }).then((data) => {
        this.showSnackBar = true;
        this.showSnackBarText = "The contract has been archived";
        this.showSnackBarIcon = "mdi-archive";
        this.showSnackBarColor = "success";
      });
    },
    actionUnarchive() {
      this.sendMutation("no-notif", "contract", UNARCHIVE_CONTRACT, {
        id: this.contract.id,
      }).then((data) => {
        this.showSnackBar = true;
        this.showSnackBarText = "The contract has been unarchived";
        this.showSnackBarIcon = "mdi-archive";
        this.showSnackBarColor = "success";
      });
    },
    actionValidate() {
      this.canValidateContractOnClick = false
      this.sendMutation("validated", "contract", VALIDATE_CONTRACT, {
        id: this.contract.id,
      }).then(() => {
        this.showSnackBar = true;
        this.showSnackBarText = "The contract has been validated";
        this.showSnackBarIcon = "check_circle_outline";
        this.showSnackBarColor = "success";
      });
    },

    actionDelete() {
      this.contractDeleteDialog = true;
    },
    switchContract(contract_id) {
      this.$router.push({
        name: "contract",
        params: {
          id: contract_id,
        },
      });
      this.fetchAndSubscribeToContract(contract_id);
      this.queryContractsList();
    },
    contractDelete() {
      this.contractDeleteDialogLoading = true;
      this.destroyMutation("contract", this.contract.id, "contracts")
        .then(() => {
          this.contractDeleteDialog = false;
          this.contractDeleteDialogLoading = false;
        })
        .catch((e) => {
          this.contractDeleteDialog = false;
          this.contractDeleteDialogLoading = false;
        });
    },
    queryContractsList() {
      this.sendQuery(CONTRACTS_INDEX)
        .then((data) => {
          this.contracts_list = data.contracts;
        })
        .catch((e) => {});
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    fetchAndSubscribeToContract(id) {
      this.ask_user_to_save = false;
      this.loading = true;
      this.fetchAndSubscribe(
        SHOW_CONTRACT,
        {
          id: id,
        },
        "contractStore",
        "contract"
      ).then(() => {
        this.loading = false;
        if (this.contract.status == "pending") {
          this.contract_score_tab = "provisionalscore";
        } else this.contract_score_tab = "realscore";

        this.backupCustomerParamtersAndAdditionnalInfos();

        // console.log(this.contract_customers_parameters);
        // console.log(this.contract_additionnal_informations);
      });
    },

    updateCustomerParameters(item_id, value) {
      this.ask_user_to_save = true;
      const list =
        value == true
          ? this.contract.customer_parameter_ids.concat(item_id)
          : this.contract.customer_parameter_ids.filter((e) => {
              return e !== item_id;
            });
      this.updateFieldInStore(
        "contractStore",
        "contract",
        "customer_parameter_ids",
        list
      );
    },
    selectAllCustomerParameters(group) {
      this.ask_user_to_save = true;
      let contain_all_group_ids = true;

      const ids = group.customer_parameters
        .filter(
          (cp) =>
            !this.cust_param_search ||
            cp.name.toLowerCase().includes(this.cust_param_search.toLowerCase())
        )
        .map((e) => {
          return e.id;
        });

      const oldIds = this.contract.customer_parameter_ids.filter((e) => {
        return !ids.includes(e);
      });

      ids.forEach((e) => {
        if (!this.contract.customer_parameter_ids.includes(e))
          contain_all_group_ids = false;
      });

      const idsToSelect = contain_all_group_ids ? oldIds : ids.concat(oldIds);
      this.updateFieldInStore(
        "contractStore",
        "contract",
        "customer_parameter_ids",
        idsToSelect
      );
    },
    updateAdditionalInformations(item_id, value) {
      this.ask_user_to_save = true;
      let list = this.contract.additional_information_ids;
      if (value == true) list = list.concat(item_id);
      else
        list = list.filter((e) => {
          return e !== item_id;
        });

      this.updateFieldInStore(
        "contractStore",
        "contract",
        "additional_information_ids",
        list
      );
    },
    selectAllAdditionalInformations() {
      this.ask_user_to_save = true;
      if (
        this.contract.additional_information_ids.length ==
        this.additionalInformationsIds.length
      )
        this.updateFieldInStore(
          "contractStore",
          "contract",
          "additional_information_ids",
          []
        );
      else
        this.updateFieldInStore(
          "contractStore",
          "contract",
          "additional_information_ids",
          this.additionalInformationsIds
        );
    },
    saveChanges() {
      this.ask_user_to_save = false;
      this.contractRenameDialog = false;
      let objectToSave = JSON.parse(JSON.stringify(this.contract));

      if (!this.contract.supplier_affiliate_company_id)
        this.contract.supplier_affiliate_company_id = "";

      if (!this.contract.customer_affiliate_company_id)
        this.contract.customer_affiliate_company_id = "";

      if (objectToSave.service_suppliers) delete objectToSave.service_suppliers;

      if (objectToSave.id === "") delete objectToSave.id;

      if (objectToSave.id)
        this.sendMutation(
          "no-notif",
          "contract",
          UPDATE_CONTRACT,
          this.contract
        ).then(() => {
          this.showSnackBar = true;
          this.showSnackBarText = "The contract has been updated";
          this.showSnackBarIcon = "save";
          this.showSnackBarColor = "success";
          this.backupCustomerParamtersAndAdditionnalInfos();
        });
    },
    discardChanges() {
      this.changes_discarded = true;
      this.ask_user_to_save = false;
      this.updateFieldInStore(
        "contractStore",
        "contract",
        "additional_information_ids",
        this.contract_additionnal_informations
      );
      this.updateFieldInStore(
        "contractStore",
        "contract",
        "customer_parameter_ids",
        this.contract_customers_parameters
      );
      this.showSnackBar = true;
      this.showSnackBarText =
        "The contract has been reverted to the initial state";
      this.showSnackBarIcon = "mdi-backup-restore";
      this.showSnackBarColor = "amber darken-2";
    },
    backupCustomerParamtersAndAdditionnalInfos() {
      //backup customer parameters and additional informations
      this.contract_customers_parameters = this.contract.customer_parameter_ids;
      this.contract_additionnal_informations = this.contract.additional_information_ids;
    },
    contractSettingsUpdateNotif() {
      this.showSnackBar = true;
      this.showSnackBarText = "The contract has been updated";
      this.showSnackBarIcon = "save";
      this.showSnackBarColor = "success";
    },
  },
  created() {
    if (this.$route.params.id)
      this.fetchAndSubscribeToContract(this.$route.params.id);
    this.queryContractsList();
  },
  beforeDestroy() {
    this.unsubscribe("contract");
  },
};
</script>

<style>
.smallerIcons {
  margin-left: 8px;
}

.hoverClass:hover {
  background-color: #eee;
}
</style>


<style lang="stylus" scoped>
.sticky-toolbars-big-menu {
  width: -webkit-calc(100% - 216px);
  width: -moz-calc(100% - 216px);
  width: calc(100% - 216px);
  position: fixed;
  margin-left: 216px;
  z-index: 2;
}

.sticky-toolbars-small-menu {
  width: -webkit-calc(100% - 76px);
  width: -moz-calc(100% - 76px);
  width: calc(100% - 76px);
  margin-left: 76px;
  position: fixed;
  z-index: 2;
}

.sticky-toolbars-no-menu {
  width: 100%;
  position: fixed;
  z-index: 2;
  margin-left: 0px;
}
</style>
